<template>
  <div id="maps" class="column is-7 is-paddingless is-hidden-touch">
    <GmapMap
      ref="mapRef"
      :center="this.$store.state.latlng"
      :options="{ disableDefaultUI: true, maxZoom: 16 }"
      :zoom="9"
      style="width: 59%; height: 88vh; position: fixed; bottom: 0;"
    >
    </GmapMap>
  </div>
</template>

<script>
import { Component } from 'vue-instantsearch';
import { gmapApi } from 'vue2-google-maps';

export default {
  mixins: [Component],
  data() {
    return {
      timeout: null,
    };
  },
  computed: {
    results() {
      return Object.keys(this.searchStore.results)
        .map(r => this.searchStore.results[r]);
    },
    markers() {
      return this.results
        .filter(f => f.locations[0] !== undefined && f.locations[0].position !== undefined);
    },
    google: gmapApi,
  },
  methods: {
    highlight(id) {
      const allResults = document.querySelectorAll('.ais-results a.media');
      allResults.forEach(result => result.classList.remove('has-background-secondary-lighter'));

      const selected = document.getElementById(id);
      if (selected) {
        selected.classList.add('has-background-secondary-lighter');
        selected.scrollIntoView({ inline: 'center' });
      }
    },
    handleResultsChange() {
      if (!(this.google && this.google.maps)) {
        setTimeout(() => this.handleResultsChange(), 50);
        return;
      }

      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        // Resizes and changes the map to fit the markers
        const bounds = new this.google.maps.LatLngBounds();

        this.markers.forEach(marker => bounds.extend(marker.locations[0].position));

        this.$refs.mapRef.$mapPromise.then((map) => {
          this.$store.dispatch('resetMarkers');
          this.populateMarkers(map);

          map.fitBounds(bounds);
          map.setCenter(bounds.getCenter());
        });
      }, 500);
    },
    populateMarkers(map) {
      this.markers.forEach((marker, index) => {
        setTimeout(() => {
          const mapMarkerInfo = new this.google.maps.InfoWindow({
            content: marker.name,
          });

          const mapMarker = new this.google.maps.Marker({
            map,
            position: marker.locations[0].position,
            title: marker.name,
            animation: this.google.maps.Animation.DROP,
          });
          mapMarker.metadata = { id: marker.id };

          mapMarker.addListener('click', () => { this.highlight(marker.id); });
          this.google.maps.event.addListener(mapMarker, 'click', () => {
            const m = this.$store.state.markers;
            Object.keys(m).forEach((key) => {
              m[key].info.close(map, m[key]);
            });
            mapMarkerInfo.open(map, mapMarker);
          });

          this.$store.dispatch('populateMarker', { mapMarker, mapMarkerInfo });
        }, 25 * index);
      });
    },
  },
  watch: {
    results() {
      this.handleResultsChange();
    },
  },
};
</script>
